export const PAGES = {
	LOGIN: {
		path: 'login'
	},
	NOTFOUND: {
		path: 'error-page'
	},
	INITIALIZE: {
		path: 'initialize'
	},
	DASHBOARD: {
		path: 'dashboard'
	},
	BACKOFFICEUSERS: {
		path: 'backoffice-users',
		LIST:
		{
			path: 'backoffice-users/list'
		},
		DETAILS:
		{
			path: 'backoffice-users/list/details'
		},
		ADD:
		{
			path: 'backoffice-users/add'
		}
	},
	MILITANTUSERS: {
		path: 'militant-users',
		LIST:
		{
			path: 'militant-users/list'
		},
		DETAILS:
		{
			path: 'militant-users/list/details'
		},
		ADD:
		{
			path: 'militant-users/add'
		},
		PROCESS:
		{
			path: 'militant-users/process',
			DETAILS:
			{
				path: 'militant-users/process/details'
			}
		},
		UPDATE_CONTACTS:
		{
			path: 'militant-users/contact-updates',
			DETAILS:
			{
				path: 'militant-users/contact-updates/details'
			}
		},
		STATS:
		{
			path: 'militant-users/stats'
		}
	},
	SYMPATHIZERS: {
		path: 'sympathizers-users',
		LIST:
		{
			path: 'sympathizers-users/list'
		},
		DETAILS:
		{
			path: 'sympathizers-users/list/details'
		},
		ADD:
		{
			path: 'sympathizers-users/add'
		},
		CANDIDATURES:
		{
			path: 'sympathizers-users/candidatures',
			LIST:
			{
				path: 'sympathizers-users/candidatures/list'
			},
			DETAILS:
			{
				path: 'sympathizers-users/candidatures/list/details'
			},
			EDIT:
			{
				path: 'sympathizers-users/candidatures/edit'
			},
			SAVED:
			{
				path: 'sympathizers-users/candidatures/saved',
				FORM:
				{
					path: 'sympathizers-users/candidatures/saved/details'
				}
			},
		}
	},
	PROCESS:
	{
		path: 'process',
		LIST:
		{
			path: 'process/list'
		},
		DETAILS:
		{
			path: 'process/list/details'
		}
	},
	PAYMENTS:
	{
		path: 'payments',
		PREVISION:
		{
			path: 'payments/prevision/list',
			LIST:
			{
				path: 'payments/prevision/list'
			},
			CREATE:
			{
				path: 'payments/prevision/create'
			},
			DETAILS:
			{
				path: 'payments/prevision/list/details'
			}
		},
		DISTRIBUTION:
		{
			path: 'payments/distribution/list',
			LIST:
			{
				path: 'payments/distribution/list'
			},
			CREATE:
			{
				path: 'payments/distribution/create'
			},
			DETAILS:
			{
				path: 'payments/distribution/list/details'
			}
		},
		MILITANT:
		{
			path: 'payments/militant/notification',
			NOTIFICATION:
			{
				path: 'payments/militant/notification'
			},
			ONDEMAND:
			{
				path: '/payments/militant/ondemand'
			}
		},
		REPORTS:
		{
			path: 'payments/reports'
		},
		DIRECT_DEBIT_CHARGES:
		{
			path: 'payments/direct-debit/charges'
		}

	},
	ELECTIONS: {
		path: '/elections',
		LIST:
		{
			path: '/elections/list',
			DETAILS:
			{
				path: '/elections/list/details'
			}
		},
		CREATE:
		{
			path: '/elections/create'
		},
		ASSINATURES:
		{
			path: '/elections/signatures',
			DETAILS:
			{
				path: '/elections/signatures/details'
			}
		},
	},
	CONGRESS: {
		path: '/congress',
		LIST:
		{
			path: '/congress/list',
			DETAILS: {
				path: '/congress/list/details'
			}
		},
		DELEGATES:
		{
			path: '/congress/delegates'
		},
		PARTICIPANTS:
		{
			path: '/congress/participants'
		},
		PLUS_OBSERVERS:
		{
			path: '/congress/plus-observers'
		},
		SEARCH:
		{
			path: '/congress/search'
		},
		STATISTICS:
		{
			path: '/congress/statistics'
		},
		PAYMENT_RETURNS:
		{
			path: '/congress/payment-returns'
		},
		EXTRA_PAYMENTS:
		{
			path: '/congress/extra-payments',
			DETAILS: {
				path: '/congress/extra-payments/details'
			}
		},
		EXPORT:
		{
			path: '/congress/export'
		},
		AUTHENTICATION:
		{
			path: '/congress/authentication'
		},
		CONFIGURATIONS:
		{
			path: '/congress/configurations',
			ORGAN_RESULTS:
			{
				path: '/congress/configurations/details'
			}
		},
		VOTES_DELEGATION:
		{
			path: '/congress/votes-delegation'
		},
	},
	CANDIDATURES:
	{
		path: 'candidatures/list',
		LIST:
		{
			path: 'candidatures/list'
		},
		SAVED:
		{
			path: 'candidatures/saved',
			FORM:
			{
				path: 'candidatures/saved/details'
			}
		},
		DETAILS:
		{
			path: 'candidatures/list/details'
		},
		VALIDATION:
		{
			path: 'candidatures/list/validation'
		},
		ARCHIVED:
		{
			path: 'candidatures/archived',
			DETAILS:
			{
				path: 'candidatures/archived/details'
			}
		}
	},
	ORGANS: {
		path: 'organs/list',
		LIST: {
			path: 'organs/list',
			DETAILS:
			{
				path: 'organs/list/details'
			}
		},
		MANDATES: {
			path: 'organs/mandates'
		},
	},
	SECTIONS: {
		path: 'sections/list',
		LIST: {
			path: 'sections/list'
		},
		DETAILS: {
			path: 'sections/list/details'
		},
	},
	CORRESPONDENCE: {
		path: 'correspondence/list',
		LIST: {
			path: 'correspondence/list',
			DETAILS: {
				path: 'correspondence/list/details'
			}
		},
		CONFIGURATIONS: {
			path: 'correspondence/configurations',
			DETAILS: {
				path: 'correspondence/configurations/details'
			}
		},
	},
	OTHERS: {
		path: 'generic',
		LISTING: {
			path: 'generic/listing'
		},
		EXTERNALACCESS: {
			path: 'generic/external'
		},
	},
	INDICATORS: {
		path: 'indicators',
		MILITANTS: {
			path: 'indicators/militants'
		},
		QUOTAS: {
			path: 'indicators/quotas'
		},
	},


}